'use client';
import { datadogRum } from '@datadog/browser-rum';
import { InitCompass } from '@nerdwallet/compass/next-init-compass';
import { env } from '@repo/env';
import { useAnalytics } from '@repo/segment/Analytics';
import { useAnalyticsPageView } from '@repo/segment/Analytics/AnalyticsPageView';
import { type PropsWithChildren, type ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export function CompassPageViewRegistration({
  children,
}: PropsWithChildren): ReactNode | undefined {
  const { pageViewId, pageName, contentId, contentSource } = useAnalyticsPageView();
  const { deployableName, deployableVersion } = useAnalytics();

  const renderInitCompass = () => {
    return (
      <ErrorBoundary
        fallback={<div />}
        onError={error => {
          datadogRum.addError(error, { message: 'Error initializing Compass' });
        }}
      >
        <InitCompass
          pageViewId={pageViewId}
          deployableName={deployableName}
          deployableVersion={deployableVersion}
          writeKey={env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}
          driverContentId={contentId}
          driverContentSource={contentSource}
          driverPageName={pageName}
        />
      </ErrorBoundary>
    );
  };

  return (
    <>
      {children}
      {renderInitCompass()}
    </>
  );
}
